import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export default function parseJwt(token: string) {
  try {
    if (!token) return null;

    const base64Url = token.split(".")[1];
    if (!base64Url) return null;

    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    base64 = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Invalid JWT token", error);
    return null;
  }
}

export const formatNumberWithSeparators = (value: number | string) => {
  const valueAsString = typeof value === "number" ? value.toString() : value;

  return valueAsString?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const truncTo = (n: number, decimals = 2): number => {
  const factor = 10 ** decimals;
  const eps = 1e-10 * Math.sign(n || 1);
  const scaled = n * factor + eps;
  return (n >= 0 ? Math.floor(scaled) : Math.ceil(scaled)) / factor;
};

export const generateNumbersWith2indent = (
  number?: number,
  isWithoutFormattedNumber?: boolean
) => {
  if (number === undefined) return "-";

  const truncatedNumber = truncTo(number, 2);

  if (isWithoutFormattedNumber) {
    return String(truncatedNumber);
  }

  const needsFixed2 =
    /^-?\d+(\.\d)?$/.test(String(truncatedNumber)) ||
    Number.isInteger(truncatedNumber);

  const printable = needsFixed2
    ? truncatedNumber.toFixed(2)
    : String(truncatedNumber);

  return formatNumberWithSeparators(printable);
};

export const parseDate = (date: string, format = "MM/DD/YY HH:mm") => {
  dayjs.extend(utc);
  return dayjs.utc(date).format(format);
};

export const capitalizeFirstLetter = (str: string): string =>
  str?.charAt(0).toUpperCase() + str?.slice(1);
